import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Purchase Order
 *
 * Lifecycle: draft → sent → acknowledged → partial → received → closed
 *            (any state can be → cancelled)
 */
export type StructureCastPOStatus =
  | "draft"
  | "sent"
  | "acknowledged"
  | "partial"
  | "received"
  | "closed"
  | "cancelled";

export interface StructureCastPurchaseOrder {
  id: string;
  poNumber: string;
  vendorId: string;
  status: StructureCastPOStatus;
  orderDate: string;
  expectedDelivery: string;
  deliveredDate: string;
  shipToAddress: string;
  shipToCity: string;
  shipToState: string;
  shipToZip: string;
  subtotal: number;
  taxAmount: number;
  shippingCost: number;
  totalAmount: number;
  createdBy: string;
  approvedBy: string;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

const SHIP_TO = {
  shipToAddress: "1625 E. Donovan Rd., Ste. C (Mid-State yard)",
  shipToCity: "Santa Maria",
  shipToState: "CA",
  shipToZip: "93454",
};

export const mockStructureCastPurchaseOrders: StructureCastPurchaseOrder[] = [
  {
    id: "sc-po-1",
    poNumber: "PO-2026-001",
    vendorId: "sc-vendor-4", // Alhambra Foundry Co.
    status: "closed",
    orderDate: "2025-12-15",
    expectedDelivery: "2026-01-05",
    deliveredDate: "2026-01-03",
    ...SHIP_TO,
    subtotal: 4000.0,
    taxAmount: 0,
    shippingCost: 250.0,
    totalAmount: 4250.0,
    createdBy: "Office",
    approvedBy: "MSCP Mgmt",
    notes: "Pre-buy for Heritage Ranch WRRF — 10 sets 1900 Sanitary Sewer CPH frames + covers. Delivered ahead of schedule.",
    createdAt: "2025-12-15T00:00:00.000Z",
    updatedAt: "2026-01-03T00:00:00.000Z",
  },
  {
    id: "sc-po-2",
    poNumber: "PO-2026-002",
    vendorId: "sc-vendor-3", // NPC Inc
    status: "sent",
    orderDate: "2026-01-22",
    expectedDelivery: "2026-02-04",
    deliveredDate: "",
    ...SHIP_TO,
    subtotal: 880.0,
    taxAmount: 0,
    shippingCost: 95.0,
    totalAmount: 975.0,
    createdBy: "Office",
    approvedBy: "MSCP Mgmt",
    notes: "Critical reorder — 10 × Press-Seal HWB 10\" boots. ETA per Press-Seal: 2/4. Freight from Fort Wayne IN.",
    createdAt: "2026-01-22T00:00:00.000Z",
    updatedAt: "2026-01-22T00:00:00.000Z",
  },
  {
    id: "sc-po-3",
    poNumber: "PO-2026-003",
    vendorId: "sc-vendor-5", // Concrete Sealants Inc
    status: "partial",
    orderDate: "2026-01-12",
    expectedDelivery: "2026-01-22",
    deliveredDate: "",
    ...SHIP_TO,
    subtotal: 432.0,
    taxAmount: 31.32,
    shippingCost: 65.0,
    totalAmount: 528.32,
    createdBy: "Office",
    approvedBy: "MSCP Mgmt",
    notes: "CS-102 sealant — 24 rolls. Received 18 of 24 on 1/22, balance back-ordered (ETA 2/5).",
    createdAt: "2026-01-12T00:00:00.000Z",
    updatedAt: "2026-01-22T00:00:00.000Z",
  },
  {
    id: "sc-po-4",
    poNumber: "PO-2026-004",
    vendorId: "sc-vendor-1", // CalPortland
    status: "draft",
    orderDate: "2026-01-28",
    expectedDelivery: "2026-02-02",
    deliveredDate: "",
    ...SHIP_TO,
    subtotal: 6450.0,
    taxAmount: 467.63,
    shippingCost: 0,
    totalAmount: 6917.63,
    createdBy: "Office",
    approvedBy: "",
    notes: "DRAFT — 30 CY 5,000 PSI mix for Group 3 (Mid-Depth MH) + Group 4 (Shallow MH) pours. Awaiting office approval.",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
  {
    id: "sc-po-5",
    poNumber: "PO-2026-005",
    vendorId: "sc-vendor-2", // Coast Steel & Rebar
    status: "acknowledged",
    orderDate: "2026-01-20",
    expectedDelivery: "2026-01-27",
    deliveredDate: "",
    ...SHIP_TO,
    subtotal: 2076.0,
    taxAmount: 150.51,
    shippingCost: 125.0,
    totalAmount: 2351.51,
    createdBy: "Office",
    approvedBy: "MSCP Mgmt",
    notes: "Rebar restock — 1200 lf #4 + 600 lf #6 ASTM A-706/A-615 Gr 60. Pre-cut to 20-ft lengths per yard spec.",
    createdAt: "2026-01-20T00:00:00.000Z",
    updatedAt: "2026-01-21T00:00:00.000Z",
  },
];

export const createMockStructureCastPurchaseOrderStore = () =>
  new MockServiceStore<StructureCastPurchaseOrder>({
    mockData: mockStructureCastPurchaseOrders,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-purchase-orders",
  });

export default mockStructureCastPurchaseOrders;
